import { render, staticRenderFns } from "./MockupSelector.vue?vue&type=template&id=e974d978&scoped=true"
import script from "./MockupSelector.vue?vue&type=script&lang=js"
export * from "./MockupSelector.vue?vue&type=script&lang=js"
import style0 from "./MockupSelector.vue?vue&type=style&index=0&id=e974d978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e974d978",
  null
  
)

export default component.exports